import { render } from "./rating_advance.vue?vue&type=template&id=20ade8e3"
import script from "./rating_advance.vue?vue&type=script&lang=js"
export * from "./rating_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__